import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResumeHomieItem } from '../interfaces-types/resume-homie.interface';

export interface ResumeHomieGeneratePayload {
  title: string;
  current_resume: string;
  job_description: string;
  labels?: string[];
  pinned?: boolean;
  color?: string;
  teamId?: string | null;
}

@Injectable({ providedIn: 'root' })
export class ResumeHomieService {
  private readonly API = 'https://resume-homie-630346558823.us-central1.run.app';

  constructor(private http: HttpClient) {}

  generateAndSave(payload: ResumeHomieGeneratePayload): Observable<{ id: string; versionId: string; resume: string }> {
    return this.http.post<{ id: string; versionId: string; resume: string }>(
      `${this.API}/resumes/generate`,
      payload
    );
  }

  listResumes(): Observable<ResumeHomieItem[]> {
    return this.http.get<ResumeHomieItem[]>(`${this.API}/resumes`);
  }

  createResume(item: Partial<ResumeHomieItem>): Observable<ResumeHomieItem> {
    return this.http.post<ResumeHomieItem>(`${this.API}/resumes`, item);
  }

  updateResume(id: string, patch: Partial<ResumeHomieItem>): Observable<any> {
    return this.http.patch(`${this.API}/resumes/${id}`, patch);
  }

  deleteResume(id: string): Observable<any> {
    return this.http.delete(`${this.API}/resumes/${id}`);
  }

  exportResume(id: string, format: 'pdf' | 'docx'): Observable<Blob> {
    return this.http.get(`${this.API}/resumes/${id}/export`, {
      params: { format },
      responseType: 'blob'
    });
  }
}
